<div class="flex flex-col items-stretch">
  <ng-container #menuContainer />
</div>
